import { render, staticRenderFns } from "./EditCarousel.vue?vue&type=template&id=23a3aba1&"
import script from "./EditCarousel.vue?vue&type=script&lang=js&"
export * from "./EditCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports